import Joi from 'joi';
import { RenderViewComponentParamsBase, renderViewComponentParamsBaseSchema, RenderViewComponentType } from '../types';

export type RenderViewCsrdMaterialityMatrixParams = VariantParams | WeightSetResult;

/** The company matrix's two views; the export draws the one the user had open. */
export type CompanyMaterialityMatrixView = 'topics' | 'matters';

type VariantParams = CommonParams & {
  variantId: string;
  jobId?: number;
  view?: CompanyMaterialityMatrixView;
  /** The Matters view's topic filter; empty or absent is every topic. */
  topicIds?: string[];
};

type WeightSetResult = CommonParams & {
  weightSetResultId: number;
};

type CommonParams = RenderViewComponentParamsBase & {
  componentType: RenderViewComponentType.CSRD_MATERIALITY_MATRIX;
  entityName: string;
};

export function isValidVariantParams(params: unknown): params is VariantParams {
  const validationResult = Joi.object(variantSchema).validate(params);
  return !validationResult.error;
}

export function isValidWeightSetResultParams(params: unknown): params is WeightSetResult {
  const validationResult = Joi.object(weightSetResultSchema).validate(params);
  return !validationResult.error;
}

const commonSchema: Joi.StrictSchemaMap<CommonParams> = {
  ...renderViewComponentParamsBaseSchema,
  componentType: Joi.string().allow(RenderViewComponentType.CSRD_MATERIALITY_MATRIX),
  entityName: Joi.string(),
};

const variantSchema: Joi.StrictSchemaMap<VariantParams> = {
  ...commonSchema,
  variantId: Joi.string().required(),
  jobId: Joi.number().optional(),
  view: Joi.string().valid('topics', 'matters').optional(),
  topicIds: Joi.array().items(Joi.string()).optional(),
};

const weightSetResultSchema: Joi.StrictSchemaMap<WeightSetResult> = {
  ...commonSchema,
  weightSetResultId: Joi.number().required(),
};
